import { render, staticRenderFns } from "./EditTipePelunasan.vue?vue&type=template&id=58351630&"
import script from "./EditTipePelunasan.vue?vue&type=script&lang=js&"
export * from "./EditTipePelunasan.vue?vue&type=script&lang=js&"
import style0 from "./EditTipePelunasan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports